import React, { useContext } from 'react'
import CustTable from '../../Common/CustTable'
import { t } from 'i18next'
import { Button, Popconfirm } from 'antd'
import { FormOutlined, DeleteOutlined } from '@ant-design/icons'
import { Link } from 'react-router-dom'
import { Color } from '../../Common/Color'
import { ActionButton } from '../../Common/Common'
import LoginContext from '../LoginContext'

const columns = (deleteUser, user) => [
  {
    width: 120,
    title: t('Admin.UserList.table.email'),
    dataIndex: 'email',
    key: 'email',
    sorter: (a, b) => a.email.localeCompare(b.email)
  },
  {
    width: 120,
    title: t('Admin.UserList.table.firstName'),
    dataIndex: 'first_name',
    key: 'firstName',
    sorter: (a, b) => a.first_name.localeCompare(b.first_name)
  },
  {
    width: 120,
    title: t('Admin.UserList.table.lastName'),
    dataIndex: 'last_name',
    key: 'lastName',
    sorter: (a, b) => a.last_name.localeCompare(b.last_name)
  },
  {
    width: 120,
    title: t('Admin.UserList.table.roles'),
    dataIndex: 'roles',
    key: 'roles',
    render: (roles) => roles?.map((r) => translatedRole(r)).join(', '),
    sorter: (a, b) => a.roles.map((r) => translatedRole(r)).join(', ').localeCompare(b.roles.map((r) => translatedRole(r)).join(', '))
  },
  {
    width: 50,
    key: 'action',
    render: (_, o) => <>
      <Link to={`/admin/users/${o.id}`}><Button shape="circle" icon={<FormOutlined />} /></Link>
      <Popconfirm
        title={`${t('Admin.UsersPage.deletePopupTitle')} "${o.last_name} ${o.first_name}"`}
        onConfirm={() => deleteUser(o)}
        placement='left'
      >
        <Button shape="circle" icon={<DeleteOutlined />} style={{ color: Color.primary }} disabled={user.roles.includes('reader')} />
      </Popconfirm>
    </>
  }
]

const translatedRole = (role) => {
  return t(`Admin.User.role.${role}`)
}

export default function UsersList ({ users, deleteUser }) {
  const { user } = useContext(LoginContext)
  
  return (
    <CustTable
      height={700}
      initColumns={columns(deleteUser, user)}
      dataSource={users}
    />
  )
}
